<template>
  <div
    class="system-communications-email-editor"
    :class="{ 'not-editable': !isEditable }"
  >
    <div
      v-show="isLoaded && !showingEmailVariablesSection"
      class="system-communications-email-editor-actions"
      id="externalSystemContainer"
    >
      <button
        id="undoButton"
        class="btn system-communications-email-editor-actions-item"
      >
        <i class="mdi mdi-undo pointer"></i>
      </button>
      <button
        id="redoButton"
        class="btn system-communications-email-editor-actions-item"
      >
        <i class="mdi mdi-redo pointer"></i>
      </button>
      <button
        id="codeEditor"
        class="btn system-communications-email-editor-actions-item"
        type="button"
      >
        <i class="mdi mdi-code-tags"></i>
      </button>

      <button
        class="btn system-communications-email-editor-actions-item"
        type="button"
        @click="showEmailVariablesSection(true)"
      >
        Variáveis do email
      </button>

      <span
        class="btn system-communications-email-editor-actions-item"
        id="changeHistoryContainer"
        style="display: none"
        >Last change: <a id="changeHistoryLink"></a
      ></span>

      <button
        class="btn system-communications-email-editor-actions-item"
        type="button"
        @click="emitConfig"
      >
        {{ $t("message.generics.message.settings") }}
      </button>
    </div>

    <div
      v-show="showingEmailVariablesSection"
      class="system-communications-email-editor-actions-variables-section"
    >
      <button
        v-for="(variable, index) in emailVariables"
        :key="index"
        v-tooltip.html="variable.htmlContent"
        class="system-communications-email-editor-actions-variables-section-btn"
        @click="copyVal(variable.variable)"
      >
        <p>
          {{ variable.title }}
        </p>
        <i class="mdi mdi-content-copy"></i>
      </button>
      <button
        class="system-communications-email-editor-actions-variables-section-close"
        @click="showEmailVariablesSection(false)"
      >
        <i class="mdi mdi-close pointer"></i>
      </button>
    </div>

    <div
      v-show="isLoaded"
      class="system-communications-email-editor-container"
      :class="{ 'not-editable': !isEditable }"
    >
      <div id="stripoSettingsContainer"></div>

      <div id="stripoPreviewContainer"></div>
    </div>

    <loading
      class="system-communications-email-editor-loading"
      v-show="!isLoaded"
    />
  </div>
</template>

<script>
import Loading from "@components/generic/Loading";
import stripo from "@packages/mixins/stripo";
import EventBus from "@packages/event-bus";

export default {
  components: {
    Loading,
  },

  mixins: [stripo],

  props: {
    email: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      default: undefined,
    },
    isEditable: {
      type: Boolean,
      default: false,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    emailVariables: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      isLoaded: false,
      credentials: undefined,
      authApi: undefined,
      showingEmailVariablesSection: false,
    };
  },

  computed: {},

  methods: {
    emitInput(val) {
      this.$emit("input", val);
    },

    async compile() {
      await this.$api.core.partner.systemCommunications.compile({
        type: this.type,
        authToken: this.authApi,
      });
    },

    async emitConfig() {
      this.$emit("config");
    },

    copyVal(val) {
      navigator.clipboard.writeText(val);

      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: this.$t("message.successMessages.message.valueCopied"),
      });
    },

    showEmailVariablesSection(value) {
      this.showingEmailVariablesSection = value;
    },
  },

  mounted() {
    this.initPlugin({
      html: this.value.htmlContent,
      css: this.value.cssStyle,
    }, 'NOTIFY#');

    EventBus.$on("TEMPLATE_COMPILE", this.compile);
  },

  beforeDestroy() {
    EventBus.$off("TEMPLATE_COMPILE", this.compile);
    this.stopPlugin();
  },
};
</script>

<style lang="scss" scoped>
.system-communications-email-editor {
  position: relative;

  &.not-editable {
    cursor: not-allowed;

    .system-communications-email-editor-actions,
    .system-communications-email-editor-container {
      pointer-events: none;
    }

    #stripoSettingsContainer {
      opacity: 0.6;
    }
  }

  .system-communications-email-editor-actions {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10;
    display: flex;

    .system-communications-email-editor-actions-item {
      background: #fff;
      box-shadow: none;
      border: 1px solid #c4c4c4;
      font-size: 13px;
      padding: 5px 15px;
      margin-right: 10px;

      &.system-communications-email-editor-actions-item_email {
        display: flex;
        align-items: center;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .system-communications-email-editor-actions-variables-section {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10;
    display: flex;

    .system-communications-email-editor-actions-variables-section-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      background: white;
      border: 1px solid #c4c4c4;
      font-size: 14px;
      gap: 2px;
      border-radius: 20px;
      padding: 5px 15px;
      margin-right: 10px;

      p {
        margin-bottom: 0;
        margin-right: 4px;
      }
    }

    .system-communications-email-editor-actions-variables-section-close {
      margin-right: 5px;
    }
  }

  .system-communications-email-editor-container {
    display: flex;

    #stripoSettingsContainer {
      width: 400px;
      border: 1px solid #c4c4c4;
      border-right: none;

      .sripo-watermark {
        display: none;
      }
    }

    #stripoPreviewContainer {
      flex: 1;
      background: #f2f2f2;
      border: 1px solid #c4c4c4;
      padding-top: 55px;
    }
  }

  .system-communications-email-editor-loading {
    margin: 30px auto;
    width: 30px;
    height: 30px;
  }
}
</style>
